<div id="to-content" (click)="openModel()" [ngClass]="{'dark': (darkmode.isDarkMode | async), 'light': !(darkmode.isDarkMode | async)}">
  <div style="width: calc(100% - 100px);">
    <ion-icon name="fa-timer"></ion-icon>
    @if (timeSrv.timeTickett.length == 1) {
      <h2 class="overflow-bullets">{{timeSrv.timeTickett[0]?.ticket?.description}}</h2>
    }
    @if (timeSrv.timeTickett.length == 0) {
      <h2>Keine Zeiten</h2>
    }
    @if (timeSrv.timeTickett.length > 1) {
      <h2>{{timeSrv.timeTickett.length}} Zeiten laufen</h2>
    }
  </div>
  @if (timeSrv.timeTickett.length == 1) {
    <div id="to-time">
      {{timeSrv.getDifference(timeSrv.timeTickett[0]?.time?.timeFrom, now, 'mm:ss')}} Std.
    </div>
  }
  @if (timeSrv.timeTickett.length != 1) {
    <div id="toup">
      <ion-icon name="fa-caret-down"></ion-icon>
    </div>
  }
</div>